import type { search as EN } from '../en/search';

export const search: Record<keyof typeof EN, string> = {
  'search.palette.placeholder': 'Seiten durchsuchen…  (> Befehle, # Schlagwörter, @ Seiten)',
  'search.palette.placeholderCommands': 'Befehl ausführen…',
  'search.palette.placeholderTags': 'Zu einem Schlagwort springen…',
  'search.palette.empty': 'Keine Ergebnisse.',
  'search.palette.openSettings': 'Einstellungen öffnen',
  'search.palette.label': 'Befehlspalette',
  'search.palette.noTagsYet': 'Noch keine Schlagwörter. Füg eines im Kopf einer Seite hinzu.',
  'search.palette.noTagsMatch': 'Keine Schlagwörter passen zu „{query}“.',
  'search.palette.noPagesMatch': 'Keine Seiten passen zu „{query}“.',
  'search.palette.noCommandsMatch': 'Keine Befehle passen zu „{query}“.',
  'search.palette.tags': 'Schlagwörter',
  'search.palette.favorites': 'Favoriten',
  'search.palette.recent': 'Zuletzt verwendet',
  'search.palette.pages': 'Seiten',
  'search.palette.events': 'Termine',
  'search.palette.createPagePrefix': 'Seite „',
  'search.palette.createPageSuffix': '“ erstellen',
  'search.palette.pageCount.one': '{count} Seite',
  'search.palette.pageCount.other': '{count} Seiten',

  'search.commands.heading': 'Befehle',
  'search.commands.newPage': 'Neue Seite',
  'search.commands.newEvent': 'Neuer Termin',
  'search.commands.setDueDate': 'Fälligkeitsdatum setzen',
  'search.commands.goToAgenda': 'Zur Agenda',
  'search.commands.goToCalendar': 'Zum Kalender',
  'search.commands.goToChat': 'Zum KI-Chat',
  'search.commands.newChildPage': 'Neue Unterseite',
  'search.commands.removeFromFavorites': 'Aus Favoriten entfernen',
  'search.commands.addToFavorites': 'Zu Favoriten hinzufügen',
  'search.commands.toggleTheme': 'Design umschalten (aktuell: {theme})',
  'search.commands.toggleDensity': 'Dichte umschalten',
  'search.commands.openTrash': 'Papierkorb öffnen',
  'search.commands.emptyTrash': 'Papierkorb leeren',
  'search.commands.shortcuts': 'Tastenkürzel',
};
